import React from 'react'

import LandingPage from '../modules/landing-page/LandingPage'

const IndexPage = () => <LandingPage />

export default IndexPage
